//
import { createContext } from 'react'

const DefaultFormValues = createContext({
    values: {},
})

export default DefaultFormValues
